
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, LookupCriteria, VendorLookupViewModel } from "@tylertech/tyler-api-types";

/**
 * VendorLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class VendorLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<VendorLookupViewModel[]>> {
        return this.$apiService.sendAuth("IVendorLookupService/Lookup", pCriteria);
    }
}
